import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateProjectArchiveMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.post(`/projects/${id}/archives`);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries([
        'projectsDashboards',
        'navigationOptions',
      ]);
      queryClient.invalidateQueries(['projectsReports', 'dashboardReports']);

      const folderId = data.included.find(
        (resource) =>
          resource.id === data.data.relationships.project.data.id &&
          resource.type === 'project',
      ).relationships.folder.data?.id;

      if (folderId) queryClient.invalidateQueries(['folders', folderId]);
    },
  });
}

export function useCreateProjectRestorationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.post(`/projects/${id}/restorations`);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries([
        'projectsDashboards',
        'navigationOptions',
      ]);
      queryClient.invalidateQueries(['projectsReports', 'dashboardReports']);

      const folderId = data.included.find(
        (resource) =>
          resource.id === data.data.relationships.project.data.id &&
          resource.type === 'project',
      ).relationships.folder.data?.id;

      if (folderId) queryClient.invalidateQueries(['folders', folderId]);
    },
  });
}

export function useDestroyProjectMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.delete(`/projects/${id}`);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries([
        'projectsDashboards',
        'navigationOptions',
      ]);
      queryClient.invalidateQueries(['projectsReports', 'dashboardReports']);

      const folderId = data.data.relationships.folder.data?.id;
      if (folderId) queryClient.invalidateQueries(['folders', folderId]);
    },
  });
}

export function useCreateProjectsBulkArchiveMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bulkArchiveParams }) => {
      const response = await axios.post('/projects/bulk_archives', {
        bulk_archive: bulkArchiveParams,
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['folders']);
      queryClient.invalidateQueries([
        'projectsDashboards',
        'navigationOptions',
      ]);
      queryClient.invalidateQueries(['projectsReports', 'dashboardReports']);
    },
  });
}

export function useCreateProjectDuplicationProcessMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ duplicationProcessParams, id }) => {
      const response = await axios.post(
        `/projects/${id}/duplication_processes`,
        { duplication_process: duplicationProcessParams },
      );
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries(['duplicationProcesses']),
  });
}

export function useUpdateProjectDocumentSdsConfigurationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ includeMsds, projectId }) => {
      const response = await axios.patch(
        `/projects/${projectId}/document_sds_configuration`,
        { document_sds_configuration: { include_msds: includeMsds } },
      );
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries(['projectHistories']),
  });
}
